// extracted by mini-css-extract-plugin
export default {"root":"Form_root__ehC8g","isTabled":"Form_isTabled__0nJeA","isMobile":"Form_isMobile__Lzm9G","heplerText":"Form_heplerText__u44+Y"};